import { Card, CardContent, CardHeader, Container, Divider, makeStyles } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AlertDialog from 'src/components/AlertDialog';
import Page from 'src/components/Page';
import CreateEditPresentationForm from 'src/components/Presentations/CreateEditPresentationForm';
import { useGoBack } from 'src/hooks/common';
import useCreatePresentation from 'src/hooks/presentations/useCreatePresentation';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const CreatePresentationView = () => {
  const { t } = useTranslation('presentations');
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const goBack = useGoBack('/app/presentations');
  const history = useHistory();
  const [createPresentation, { isLoading, data, isError, error }] = useCreatePresentation();

  const handleSubmit = ({ values }) => createPresentation(values);

  const handleCancel = () => {
    history.push('/app/patients', { replace: true });
  };

  useEffect(() => {
    if (!isLoading && !isError && data) {
      enqueueSnackbar(t('modals.success.text_create_presentation'), { variant: 'success' });

      goBack();
    }
  }, [data, enqueueSnackbar, goBack, isError, isLoading, t]);

  return (
    <Page className={classes.root}>
      <Container maxWidth="lg">
        <Card>
          <CardHeader
            subheader={t('labels.createPresentation_subtitle')}
            title={t('labels.createPresentation_title')}
          />
          <Divider />
          <CardContent>
            <CreateEditPresentationForm
              handleFormSubmit={handleSubmit}
              handleCancel={handleCancel}
              action="create"
            />

            {isError && (
              <AlertDialog
                title={t('modals.error.title_create_presentation')}
                text={error?.message || t('modals.error.text_create_presentation')}
                type="error"
              />
            )}
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default CreatePresentationView;
